var MDB = window.MDB || {};
MDB.Login = MDB.Login || {};

(function () {

    function getUserId() {
        var url = window.location.href;
        var userIdIndexStart = (url.lastIndexOf('/') + 1);
        var userIdIndexEnd = url.lastIndexOf('?');

        if (userIdIndexEnd === -1) {
            userIdIndexEnd = url.length;
        }

        var userId = url.substring(userIdIndexStart, userIdIndexEnd);
        return userId;
    }

    function bootSms() {
        var sendCode = $('#send-code-sms');
        
        sendCode.click(function () {
            MDB.Login.sendCodeSms();
        });
    }

    $.extend(MDB.Login,
        {
            bootTfa: function () {
                var codeControl = MDB.Login._tfaCodeControl = $('#Code');

                if ($.connection && $.connection.hub) {
                    MDB.configureSignalR($.connection);

                    var hub = $.connection.TotpAuthenticatorHub;
                    var hubClient = hub.client;

                    hubClient.fillAndSubmitCode = MDB.Login.fillAndSubmitCode;

                    MDB.startSignalR().done(function () {
                        hub.server.subscribe();
                    });
                } else {
                    console.alert('Failed to boot SignalR! Push notifications not available');
                }

                //Unfortunately. this breaks the verifycode tests
                //MDB.Login.loginKeyup(codeControl);
                codeControl.focus();

                var form = $('#verify-code-form');
                form.on('submit', function(e) {
                	// prevent submitting the form multiple times
                	if(form.data('submit-in-progress') === true) {
                		e.preventDefault();
                		return false;
                	}
                	form.data('submit-in-progress', true);
                	$('body').addClass('cursor-progress');
                    setTimeout(function() {
                        form.data('submit-in-progress', false);
                    },
                    30000);
                });

                bootSms();
            },
            bootTfaConfirm: function (opts) {
                //Quickfix to achieve legacy compatibility... for now
                window.submitCode = function submitCode() {
                    MDB.Login.confirmCode(opts.codeConfirmedUrl);
                };

                MDB.Account.Tfa.renderQrCodes();
                
                var control = MDB.Login._tfaCodeControl = $('#GoogleAuthViewModel_Code');

                //Unfortunately. this breaks the verifycode tests
                //MDB.Login.loginKeyup(codeControl);
                control.focus();

                control.on('keydown', function (e) {
                    //Submit on enter press + valid form
                    if (e.which === 13 && this.value.length === 6) {
                        submitCode();
                    }
                });

                bootSms();
            },
            sendCodeSms: function() {
                var userId = getUserId();
                var resultText = $('#send-code-result');
                
                resultText.html('');
                resultText.prop('class', 'hidden');

                $.ajax({
                    url: "/Account/SendCodeSms",
                    type: "GET",
                    data: {
                        userId: userId
                    },
                    cache: false,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    error: function() {
                        resultText.prop('class', 'text-danger');
                        resultText.html(MDB.loadResourceString('Login_TwoFactorSms_SmsFailed_Message'));
                    },
                    success: function (result) {
                        if (result && result.success === true) {
                            resultText.prop('class', 'text-success');
                            resultText.html(MDB.loadResourceString(result.message));
                        } else {
                            resultText.prop('class', 'text-danger');
                            resultText.html(MDB.loadResourceString(result.message));
                        }
                    }
                });
            },
            fillAndSubmitCode: function (code) {
                var control = MDB.Login._tfaCodeControl;
                control.val(null);
                MDB.Login.typeText(control, code).done(function () {
                    control.closest('form').trigger('submit');
                });
            },
            confirmCode: function (codeConfirmedUrl) {
                var control = MDB.Login._tfaCodeControl
                    , authCode = control.val()
                    , otherControls = $('#confirmAuth,#authReadme');
                
                otherControls.hide();

                var userId = getUserId();

                $.ajax({
                    url: "/Account/Confirm2FAuthSettings",
                    type: "GET",
                    data: {
                        code: authCode,
                        userId: userId,
                        returnUrl: codeConfirmedUrl
                    },
                    cache: false,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    error: function () {
                        otherControls.show();
                    },
                    success: function (result) {
                        if (result && result.success === true) {
                            window.location.href = result.returnUrl;
                        } else {
                            if (result.message) {
                                alert(result.message);
                            }

                            otherControls.show();
                        }
                    }
                });
            },
            loginKeyup: function (control) {
                control.keyup(function (e) {
                    var me = $(this);

                    //Enter key pressed or 6 characters entered
                    if (e.keyCode === 13 || me.val().length === 6) {
                        $('.btn-login').click();
                    }
                });
            },
            //TODO: Move to marketingdb.js/shared util script
            typeText: function (targetSelector, text, delay) {
                if (!_.isString(text)) {
                    return $.Deferred().reject("Parameter 'text' required!").promise();
                }

                var args = arguments
                    , nextFn = args.callee;

                targetSelector = $(targetSelector);

                return $.Deferred(function (deferred) {
                    var targetVal = targetSelector.val(),
                        curLen = targetVal.length;

                    if (curLen >= text.length) {
                        //Begin a resolve chain starting from the top
                        deferred.resolve();
                        return;
                    }

                    setTimeout(function () {
                        targetSelector.val(targetVal + text[curLen]);
                        nextFn.apply(null, args).done(function () {
                            deferred.resolve();
                        });
                    }, delay || 100);
                }).promise();
            },
            checkForCapsLock: function () {
                $('#Password').keyup(function() {
                    var caps = event.getModifierState && event.getModifierState('CapsLock');

                    if (caps) {
                        $('#caps-check-label').show();
                    } else {
                        $('#caps-check-label').hide();
                    }
                });
            }
        });
}());